// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5d055777","455":"3073a856","644":"ca4496ad"}[chunkId] + ".chunk.js";
};